<template>
	<div class="d-flex flex-row no-gutters h-100 w-100 provider-content" ref="container">
		<div :class='"position-relative bg-light border-right-separator no-gutters h-100 column-list column-list" + event'>
			<loading ref="loading"></loading>
			<div class='d-flex flex-column h-100'>
				<header class="list-header" style="z-index: 100;">
					<!-- <h2 class="h4 p-2">{{title + getItemCount() }}</h2> -->
					<h2 class="h4 p-2 m-0" v-if='this.quickFilters.unassigned == false && this.quickFilters.assigned == false && this.quickFilters.mine == false && this.quickFilters.closed == false && this.quickFilters.advanced == false && this.quickFilters.waiting == false' >All {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if='this.quickFilters.unassigned == true'>{{$t('translations.new')}} {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if='this.quickFilters.assigned == true'>{{$t('translations.assigned')}} {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if='this.quickFilters.mine == true'>{{$t('translations.mine')}} {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if='this.quickFilters.closed == true'>{{$t('translations.completed')}} {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if='this.quickFilters.waiting == true'>{{$t('translations.waiting')}} {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if='this.quickFilters.advanced == true'>{{$t('translations.filtered')}} {{ getItemCount() }}</h2>
					<h2 class="h4 p-2 m-0" v-else-if="title">{{ autobrand("translations." + title)}} {{ getItemCount() }}</h2>
                    <h2 class="h4 p-2 m-0" v-else-if="titleBrandKey">{{ tBrandKey(titleBrandKey)}} {{ getItemCount() }}</h2>
					<div v-if='event != "patient" && event != "thread" && event != "feedback" && event != "log" && event != "staff"' class="btn-filter-toggle">
		                <button type="button" class="btn btn-link" v-on:click='showFilter'><img src="img/icon-search.svg">
							<span class="sr-only">Search</span>
						</button>
		            </div>



					<template v-if='Object.keys(quickFilters).length'>
						<div class="filter-container-wrap d-flex">
							<button :title="$t('translations.new')" v-on:click.prevent='toggleFilter("unassigned")' :aria-pressed='quickFilters["unassigned"]' :class='"btn btn-unassigned" + (quickFilters["unassigned"] ? " active" : "")'></button>
							<button :title="$t('translations.assigned')" v-on:click.prevent='toggleFilter("assigned")' :aria-pressed='quickFilters["assigned"]' :class='"btn btn-assigned" + (quickFilters["assigned"] ? " active" : "")'></button>
							<button :title="$t('translations.assigned_to_me_or_my_groups')" v-on:click.prevent='toggleFilter("mine")' :aria-pressed='quickFilters["mine"]' :class='"btn btn-mine" + (quickFilters["mine"] ? " active" : "")'></button>
							<!-- <button title="Waiting" v-on:click.prevent='toggleFilter("waiting")' :aria-pressed='quickFilters["waiting"]' :class='"btn btn-waiting" + (quickFilters["waiting"] ? " active" : "")'></button> -->
							<button :title="autobrand('translations.waiting_for_patient_assigned_to_me_or_my_groups')" v-on:click.prevent='toggleFilter("waiting")' :aria-pressed='quickFilters["waiting"]' :class='"btn btn-waiting" + (quickFilters["waiting"] ? " active" : "")'></button>
							<button :title="$t('translations.completed')" v-on:click.prevent='toggleFilter("closed")' :aria-pressed='quickFilters["closed"]' :class='"btn btn-complete" + (quickFilters["closed"] ? " active" : "")'></button>
							<button :title="$t('translations.advanced_search')" v-on:click.prevent='showFilter();' :aria-pressed='quickFilters["advanced"]' :class='"btn btn-advanced" + (quickFilters["advanced"] ? " active" : "")'></button>
						</div>
					</template>
                    <template v-if='Object.keys(quickFilters).length && $root.provider.site.length > 1'>
                        <div class='d-flex flex-row-reverse'>
                            <div class='d-flex align-items-baseline col-xl-12 col-lg-24 pb-1 pr-1 pl-0'>
                                <label class="site-select-label pr-1 pl-2 m-0">{{ $t('translations.site')}}:</label>
                                <b-form-select v-on:change='changeSite()' v-model='site_id' size="sm" class='invisible-select pl-1'>
                                    <option value=''>{{$t('translations.all')}}</option>
                                    <option v-for='site in $root.provider.site' :key='site.id' :value='site.id'>{{site.name}}</option>
                                </b-form-select>
                            </div>
                            <button v-if='quickFilters && (quickFilters["advanced"] == true || quickFilters["closed"] == true)' 
                                    type="button" 
                                    class="mr-auto ml-2 btn-sm btn-light btn-refresh" v-on:click='getResults()'>
                                <span class="sr-only">Refresh</span>
                            </button>
                        </div>
                        
                    </template>
				</header>
				<inline-filter 
                    v-if='event == "patient"' 
                    :key='event' ref="listFilter" 
                    :modalid='modalid' 
                    v-on:filterUpdated='getResults(1)' 
                    :subtitle="this.$t('translations.tooltip_one_field_is_enough')"
                    :show_duplicates='true'></inline-filter>
                <inline-filter v-else-if='event == "staff"' :key='event' ref="listFilter" :modalid='modalid' v-on:filterUpdated='getResults(1)'></inline-filter>
				<list-filter v-else :expanded='event == "thread"' :key='event' ref="listFilter" :modalid='modalid'></list-filter>
				<div v-if='event != "patient" && $refs.listFilter'>
					<p v-if='$refs.listFilter && $refs.listFilter.$refs.search.value' class='search-lozenge badge badge-primary badge-pill'>
						{{$refs.listFilter.$refs.search.value}}
						<a v-on:click.prevent='$refs.listFilter.$refs.search.value = ""; getResults(1);' href="#">&times;</a>
					</p>
					<p v-for='(filter, index) in $refs.listFilter.appliedFilters' v-if='$refs.listFilter.filterHasValue(filter)' class='search-lozenge badge badge-primary badge-pill'>
						{{$refs.listFilter.getFilterDefinition(filter)}}
						<a v-on:click.prevent='$refs.listFilter.appliedFilters.length > 1 ? $refs.listFilter.removeFilterByIndex(index) : $refs.listFilter.clearFilters();$refs.listFilter.applyFilters()' href="#">&times;</a>
					</p>
				</div>

				<div class="errors">
	                <template v-for="(error, key) in errors">
	                    <p class="alert alert-warning" v-for="message in error">{{message}}</p>
	                </template>
	            </div>
				<div class='flex-grow-1-scroll h-100'>
					<div class="p-2" v-show='items.data instanceof Array && items.data.length === 0'>{{$t('translations.no_items_found')}}.</div>
					<component v-bind:is='displayelement'></component>
				</div>
				<footer class='list-footer'>
					<div class="d-flex flex-row flex-wrap align-items-stretch justify-content-between">
						<button v-if='canCreate()' class="align-self-center btn btn-circle mr-2" v-on:click="openCreate">
                            <span class="fa fa-plus"></span>
                        </button>
						<!-- <pagination :limit="0" ref="paginator" :data="items" v-on:pagination-change-page="getResults" ></pagination> -->
						<paginator class='align-self-center small' :pagination="items"
		                     @paginate="getResults()"
							 :offset="1"
                             :simple="true">
						</paginator>

						<select v-if='event == "thread"' v-model='sort' v-on:change='setSort' class="form-control-sm btn-sort__date small col">
							<option v-bind:value='{field: "created_at", dir: "asc"}'>{{$t('translations.oldest_on_top')}}</option>
							<option v-bind:value='{field: "created_at", dir: "desc"}'>{{$t('translations.newest_on_top')}}</option>
						</select>

						<div v-if='event == "thread"' class="align-self-center mr-1">
							<!-- <label class='small'>Per Page:</label> -->
							<b-form-select class="form-control w-auto per-page-select" v-model='per_page' v-on:change='changePerPage()'>
								<option>10</option>
								<option>20</option>
								<option>50</option>
							</b-form-select>
						</div>

						<div v-if='event == "userduplicate"'>
							<router-link to="/patient-list" tag="li" class="btn btn-light btn-sm btn-round">
	                            {{ autobrand('translations.patient_search') }}
	                        </router-link>
						</div>

					</div>
				</footer>
			</div>
		</div>

		<div class="flex-grow-1-scroll h-100 w-100">
			<global-message ref="globalmessage"></global-message>

			<router-view ref='content2' name='content2' :key="$route.fullPath"></router-view>

		</div>
	</div>

</template>

<script>
 /**
  * @vue-prop {String} route - The route to use for API calls
  * @vue-prop {String} event - The event name
  * @vue-prop {String} model - The model name
  * @vue-prop {String} path - The router path
  * @vue-prop {String} title - The title of the listing
  * @vue-prop {String} title - The vue component that we will use to display the items.
  * @vue-prop {String} modalid - The ID used for the internal modal used for filters.
  * @vue-prop {Boolean} subroute=1 - Whether the router is a subroute
  * @vue-data {Object|Array} items - The items to list
  * @vue-data {Object|Array} filterFields - The filter fields available
  * @vue-data {Number} page - The current page
  * @vue-data {Object|Array} errors - An array of errors to display
  * @vue-data {Object|Array} quickFilters - The quick filters available
  * @vue-computed {Boolean} stale Whether we have been disconnected from the server websockets.
  */
	export default {
		props: {
			'route': {},
			'event': {},
			'model': {},
			// @todo Review this as we can just use this.$router.path
			'path': {},
			'title': {},
            'titleBrandKey': {},
			'displayelement': {},
			'modalid': {},
			'subroute': {
				default: 1
            }
		},
		data: function(){
			return {
				items: {},
				filterFields: {},
				page: 1,
				errors: [],
				notification: "",
				test_state: true,
				per_page: 10,
				quickFilters: {
					//assigned: false
				},
                sort: {field: "created_at", dir: "desc"},
                resultsRequestTimer: null,
                site_id: "",
                resultRequests: [],
                stale: false
			};
		},
		computed: {
            provider_id: {
                get: function() {
                    if(this.is_network_admin()) {
                        return this.$root.admin_provider_id;    
                    }
                    else {
                        return this.$root.provider.id;
                    }
                }
            },
		},
		watch: {
             provider_id(new_provider_id, old_provider_id) {
                this.$router.push({path: "/" + this.event + "-list"});
                this.getResults(1)
            },
            /**
             * NOT SURE WHY THIS WAS ADDED, BUT IT DOESN'T SEEM TO EVER GET CALLED
             * 
             * @todo Test if it is used, and if not remove it. Confusing extra call to initData.
             */
			route: function (val) {
		 		this.initData();
		    },
    		"$root.connected" (newState, oldState) {
                if(newState == true && oldState == false) {
                    if(this.appActive()) {
                        this.getResults();
                    }
                    else {
                        this.stale = true;
                    }
                }
            },
            "$root.visibility" (newState, oldState) {
                if(newState == "visible" && this.stale) {
                    this.getResults();
                }
		    },
			per_page(value) {
				this.setSetting("per_page", value);
			},
			sort(value) {
				this.setSetting("sort", value);
            },
            site_id(value) {
				this.setSetting(this.event + "_site_id", value);
            },
            quickFilters: {
                handler(val) {
                    this.setSetting(this.event + "_quick_filter", this.quickFilters);
                },
                deep: true
            }

		},
		created() {
        },
		beforeDestroy() {
			this.deinitData();
		},
		beforeRouteLeave (to, from, next) {
			this.deinitData();
    		next();
		},

		mounted() {
            this.per_page = this.getSetting("per_page");
            this.sort = this.getSetting("sort");

            // Check that the site_id is valid
            var thisSiteId = this.getSetting(this.event + "_site_id", "");
            if(this.$root.provider.site.find(obj => {return obj.id == thisSiteId})) {
                this.site_id = thisSiteId;
            }
            else {
                this.setSetting(this.event + "_site_id", "");
            }
            
            this.quickFilters = this.getSetting(this.event + "_quick_filter", {});
            if(this.quickFilters["advanced"] && this.quickFilters["advanced"] == true) {
                this.resetQuickFilters();
            }
            
			this.initData();
		},

		methods: {
			deinitData() {
				if(this.event == "thread") {
					window.Echo.leave('thread.' + this.$root.user.provider.id);
                }
                if(this.resultsRequestTimer) {
                    console.log("Clearing timer.")
                    clearTimeout(this.resultsRequestTimer);
                }
			},
			/**
			 * Toggle quick filters
			 * @param  {String} filter The filter to toggle
			 */
			toggleFilter(filter) {
				this.$router.push({path: "/" + this.event + "-list"});
				for(var index in this.quickFilters) {
					if(index == filter) {
						//this.quickFilters[index] = !this.quickFilters[index];
						this.quickFilters[index] = true;
					}
					else {
						this.quickFilters[index] = false;
					}
				}
				if(filter !== "advanced") {
					this.$refs.listFilter.clearFilters(null);
					this.$refs.listFilter.appliedFilters = [];
					this.getResults(1);
				}
            },
            updateItem(newItem, ignore = []) {
                var found = false;

                if(this.items && Array.isArray(this.items.data)) {
					console.log("Processing min update.");
					for(var index in this.items.data) {
						if(this.items.data[index].id == newItem.thread.id) {
							found = true;
							//Vue.set(this.items.data, index, newItem.thread);
							for (var attrname in newItem.thread) {
								if(!ignore.find(value => {return attrname == value})) {
									console.log("Setting: " + attrname + ")" + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
									this.items.data[index][attrname] = newItem.thread[attrname];
								}
								else {
									console.log("Ignoring: " + attrname);
								}
							}
						}
					}
                }
                console.log("updateItem: " + found);
                return found;
            },
			addOrUpdateItem(newItem, ignore = []) {
                // Note that we currently fall back to calling getResults
                // This is because the user may be in a filtered listing that
                // shouldn't display the new item. The logic for the filters is
                // quite complex, and we don't want to duplicate it client side.
				if(!this.updateItem(newItem, ignore)) {
                    this.requestGetResults();
                    //this.getResults(undefined, false);
				}
				//
				// if(!found && this.items.current_page == 1) {
				// 	if(this.items && Array.isArray(this.items.data)) {
				// 		this.items.data.unshift(newItem.thread);
				// 		if(this.items.data.length > this.items.per_page) {
				// 			this.items.data.pop();
				// 		}
				// 	}
				// 	else {
				// 		this.getResults(undefined, false);
				// 	}
				// }
            },
            haveIncomingFilterParameters() {
                if(this.$route.params.assigned_to) {
                    return true;
                }
                return false;
            },
            resetQuickFilters() {
                this.$set(this.quickFilters, 'assigned', false);
                if(this.$root.provider.demo_mode) {
                    this.$set(this.quickFilters, 'unassigned', false);
                    this.$set(this.quickFilters, 'mine', true);
                }
                else {
                    this.$set(this.quickFilters, 'unassigned', true);
                    this.$set(this.quickFilters, 'mine', false);
                }

                // this.$set(this.quickFilters, 'waiting', false);
                this.$set(this.quickFilters, 'closed', false);
                this.$set(this.quickFilters, 'waiting', false);
                this.$set(this.quickFilters, 'advanced', false);
            },
			initData() {
				this.setLoading(true);
				this.items = {};
				this.errors = [];

				if(this.event == "thread") {
                    if(Object.keys(this.quickFilters).length == 0) {
                        this.resetQuickFilters();
                    }
                    //this.quickFilters["assigned"] = false;
                    window.Echo.private('thread.' + this.$root.user.provider.id)
						.listen('NewThread', (e) => {
                            if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                                // Don't do any auto-updates
                            }
                            else {
                                if(e.thread) {
                                    // Show a notice for a non-QA thread
                                    if(!e.thread.question_group || e.thread.question_group.question_group_type_id != 1) {
                                        //this.addNotification({type: "success", content: 'New request'});
                                        //this.getResults(undefined, false);
                                        this.requestGetResults();
                                        //this.addOrUpdateItem(e);
                                    }
                                    // Update the thread list if a QA is in progress and it was created by the current staff member.
                                    else if(e.thread.created_by == this.$root.user.id) {
                                        //this.getResults(undefined, false);
                                        this.requestGetResults();
                                        //this.addOrUpdateItem(e);
                                    }
                                }
                                else {
                                    console.error("No thread data found in NewThread.")
                                }
                            }
						})
						.listen('UpdateThread', (e) => {
                            if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                                // Don't do any auto-updates
                            }
                            else {
                                if(e.thread) {
                                    if(!e.thread.question_group || e.thread.question_group.question_group_type_id != 1) {
                                        //this.addNotification({type: "success", content: 'Request updated'});
                                        //this.getResults(undefined, false);
                                        this.requestGetResults();
                                        //this.addOrUpdateItem(e);
                                    }
                                }
                                else {
                                    console.error("No thread data found in UpdateThread.")
                                }
                            }
                        })
                        .listen('UpdateThreadMin', (e) => {
                            //console.log("UpdateThreadMin received.");
                            //console.log(e);
                            if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                                // Don't do any auto-updates
                            }
                            else {
                                if(e.thread) {
                                    if(!e.thread.question_group || e.thread.question_group.question_group_type_id != 1) {
                                        this.addOrUpdateItem(e, ["user_thread_read_status"]);
                                        //this.getResults(undefined, false);
                                    }
                                }
                                else {
                                    console.error("No thread data found in UpdateThreadMin.")
                                }
                            }
                        })
                        .listen('UpdateThreadImmediate', (e) => {
							//console.log("UpdateThreadImmediate received.");
                            //console.log(e);
                            if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                                // Don't do any auto-updates
                            }
                            else {
                                if(e.thread) {
                                    if(!e.thread.question_group || e.thread.question_group.question_group_type_id != 1) {
                                        //this.forceGetResults();
                                        this.requestGetResults();
                                    }
                                }
                                else {
                                    console.error("No thread data found in UpdateThreadImmediate.")
                                }
                            }
                        });
				}
				else {
					this.quickFilters = {};
                }
                if(this.$root.lookup.relatedData[this.route]) {
                    this.processRelatedData(this.$root.lookup.relatedData[this.route]);
                }
                else {
                    axios.get(this.route + '/relatedData').then((res) => {
                        this.$root.lookup.relatedData[this.route] = res.data;
                        this.processRelatedData(res.data);
                    }).catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
            },
            processRelatedData(data) {
                for(var key in data) {
                    this[key] = data[key];
                }
                this.initFilters();

                if(this.event != "patient" && this.event != "staff") {
                    if(!this.haveIncomingFilterParameters()) {
                        this.getResults(1);
                    }
                }
                else {
                    this.setLoading(false);
                }
            },
			setFiltersFromRouteParams() {
                if(this.haveIncomingFilterParameters()) {
                    this.site_id = "";
                    this.$refs.listFilter.setFilter("assigned_to", "=", this.$route.params.assigned_to);
                    delete(this.$route.params.assigned_to);
                }
            },
			initFilters() {
                if(this.$refs.listFilter) {
                    if(this.$root.lookup.filters[this.route]) {
                        Vue.nextTick(() => {
                            this.$refs.listFilter.filterFields = this.$root.lookup.filters[this.route];
                            this.$refs.listFilter.clearFilters(null);
                            this.setFiltersFromRouteParams();
                        });
                    }
                    else {
                        this.setLoading(true);
                        axios.get(this.route + '/getFilters').then((res) => {
                            this.$root.lookup.filters[this.route] = res.data;
                            this.$refs.listFilter.filterFields = res.data;
                            this.$refs.listFilter.clearFilters(null);
                            this.setFiltersFromRouteParams();
                        });
                    }
                }
			},
			changePerPage() {
				// Funny race condition in firefox so we have to do this nextTick.
				Vue.nextTick(() => {this.getResults(1)});
			},
			setSort() {
				this.getResults();
            },
            forceGetResults() {
                console.log('Forcing immediate update.')
                if(this.resultsRequestTimer) {
                    clearTimeout(this.resultsRequestTimer);
                    this.resultsRequestTimer = null;
                }
                var backoff = 2000 + (Math.random() * 3000);
                this.requestGetResults(backoff);
            },
            updateResultRequests() {
                var resultIndex = this.resultRequests.length;
                while (resultIndex--) {
                    if (this.moment().diff(this.resultRequests[resultIndex], "minutes") >= 5) {
                        this.resultRequests.splice(resultIndex, 1);
                    }
                }
                this.resultRequests.push(this.moment());
            },
            requestGetResults(backoff) {
                this.updateResultRequests();
                // this.getResults(undefined, false);
                // return;
                if(this.resultsRequestTimer) {
                    // Toyed with the idea of continual back-off, but we would need some way to say enough is enough.
                    //clearTimeout(this.resultsRequestTimer);
                    //this.addNotification({type: "warning", content: 'Waiting for request update.'});
                    console.log('Waiting for request update.')
                    return;
                }

                if (typeof backoff === 'undefined') {
					backoff = (Math.min(this.resultRequests.length, 100) * 1000) + (Math.random() * 15000);
				}

                console.log('Backing off for ' + (backoff / 1000) + ' seconds.');
                this.resultsRequestTimer = setTimeout(() => {
                    // Clear has to happen outside of the get as the query may have already occurred if
                    // we wait for the promise to return
                    this.resultsRequestTimer = null;
                    this.getResults(undefined, false).then(() => {
                        // See note above.
                        //this.resultsRequestTimer = null;
                    });
                    //this.addNotification({type: "success", content: 'Request timeout update after ' + (backoff / 1000) + 'seconds.'});
                    console.log('Request timeout update after ' + (backoff / 1000) + ' seconds.')
                }, backoff);
            },
			// @updatehere
			getResults(page, showLoading, prevent) {
                if(!this.appActive()) {
                    this.stale = true;
                    return Promise.reject("Application is not active. Data set to 'stale'. Will update when active.");
                }
                if (typeof showLoading === 'undefined') {
					showLoading = true;
				}

				if(showLoading) {
					this.setLoading(true);
				}

				if (typeof page !== 'undefined') {
					this.items.current_page = page;
				}

				var search = (this.$refs && this.$refs.listFilter ? this.$refs.listFilter.$refs.search.value : "");

				var filter = encodeURIComponent(JSON.stringify(this.quickFilters));

				if(this.event == "thread") {

					if(this.quickFilters['assigned'] == false &&
							this.quickFilters['unassigned'] == false &&
							this.quickFilters['mine'] == false &&
							this.quickFilters['waiting'] == false &&
							this.quickFilters['closed'] == false &&
							this.quickFilters['advanced'] == false) {

						var defaultFilter = {};
						defaultFilter['unassigned'] = true;
						defaultFilter['mine'] = true;

						filter = encodeURIComponent(JSON.stringify(defaultFilter));
					}

					if(this.quickFilters['advanced'] == true && this.$refs && this.$refs.listFilter && this.$refs.listFilter.filterShown) {
						var singleFields = this.$refs.listFilter.appliedFilters.filter(obj => {
							return (obj.field == "id" /* || obj.field == "user.surname" || obj.field == "user.dob" */) && obj.value;
						});
						if(singleFields.length) {
							search = encodeURIComponent(JSON.stringify(singleFields));
						}
						else {
                            // if(this.site_id) {
                            //     search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters.concat([{"field":"site_id","type":"=","value":this.site_id}])));
                            // }
                            // else {
                            search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters));
                            // }
						}
						// var overrideFilters = JSON.parse(JSON.stringify(this.quickFilters));
						// overrideFilters['closed'] = true;

						filter = "";
					}
				}
				else if(this.$refs && this.$refs.listFilter && this.$refs.listFilter.filterShown) {
					search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters));
				}

                var params = {sort: this.sort};

                // Made this specific to user groups for now, but it can be used for
                // other event types if we move stuff around in the network admin interface.
                if(this.is_network_admin() && (
                        this.event == "usergroup"
                        || this.event == "feedback")) {
                    params.provider_id = this.provider_id;
                }

				return axios.get(this.route + '?site_id=' + (this.site_id ? this.site_id : "") + '&search=' + search + '&filter=' + filter + '&page=' + this.items.current_page + '&p=' + this.per_page, {params: params}).then((res) => {
					//console.log("current_page: " + res.data.current_page);
					//console.log("last_page: " + res.data.last_page);
					if(res.data.current_page > res.data.last_page && prevent !== true) {
						console.log("Re-searching with page in range.");
						this.items = {};
						this.getResults(res.data.last_page, showLoading, true)
					}
					else {
						this.setLoading(false);
						this.items = res.data;
					}
				}).catch((error) => {
					if(showLoading) {
						this.setLoading(false);
					}
					this.handleError(error, "load");
					//this.$router.push({path: "/" + this.event + "-list"});
				});

			},
			getOpenLink(event, id) {
				if(this.subroute) {
					return {path: "/" + this.event + "-list" + "/" + this.event + '-show/' + id};
				}
				else {
					return {path: "/" + this.event + '-show/' + id};
				}
            },
            // Deprecated. Use getOpenLink and a proper router-link instead.
            openView(event, id) {
				if(this.subroute) {
					this.$router.push({path: "/" + this.event + "-list" + "/" + this.event + '-show/' + id});
				}
				else {
					this.$router.push({path: "/" + this.event + '-show/' + id});
				}
			},
			openCreate(event) {
				this.$router.push({path: "/" + this.event + "-list" + "/" + this.event + '-create'});
			},
			debug() {
				console.log(this.items.data)
			},
			showFilter() {
				$(this.$refs.listFilter.$refs.modal).modal("show");
				setTimeout(function() {
					if (this.$refs.listFilter.filterShown) {
    					$(this.$refs.listFilter.$refs["filter-value-0"]).focus();
    				}
    				else {
    					$(this.$refs.listFilter.$refs.search).focus();
    				}
		        }.bind(this), 500);

			},
			canCreate() {
				if(this.event == "thread") {
					return false;
				}
				if(this.event == "staff" && (this.is_admin() || this.is_superuser() || this.is_network_admin())) {
					return true;
				}
				if(this.event == "news" && (this.is_network_admin())) {
					return true;
				}
				if(this.event == "presetmessage") {
					return true;
				}
				if(this.event == "provider" && (this.is_network_admin())) {
					// Disabled for now until we complete the component
					return true;
				}
				if(this.event == "patient") {
					return true;
				}
				if(this.event == "usergroup" && (this.is_admin() || this.is_superuser())) {
					return true;
				}

				return false;
			},
			viewNext(id) {
				var foundNext = false;
				this.items.data.forEach((value, index, array) => {
					if(this.items.data[index].id == id) {
						if(this.items.data.length > index + 1) {
							this.$router.push({path: "/" + this.event + "-list/" + this.event + "-show/" + this.items.data[index + 1].id});
							foundNext = true;
						}
					}
				});
				if(!foundNext) {
					this.$router.push({path: "/" + this.event + "-list"});
					return false;
				}

            },
            changeSite() {
                Vue.nextTick(() => {this.getResults(1)});
            },
            getItemCount() {
                if(this.items && this.items.data && this.items.total) {
                    return "[" + this.items.total + "]";
                    //return "--";
                }
                return "";
            },
		}
    }
</script>
